import { useEffect, useMemo, useState } from 'react'
import { getHelpSettings } from '../../services/helpSettings.service'
import { buildWhatsAppLinkAR } from '../../utils/whatsapp'

function FashionContact() {
  const [settings, setSettings] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let mounted = true
    const load = async () => {
      try {
        setLoading(true)
        const data = await getHelpSettings()
        if (mounted) setSettings(data)
      } catch {
        if (mounted) setSettings(null)
      } finally {
        if (mounted) setLoading(false)
      }
    }
    load()
    return () => {
      mounted = false
    }
  }, [])

  const contact = settings?.contact || null

  const items = useMemo(() => {
    const social = contact?.socialMedia || {}
    return ([
    {
      title: 'WhatsApp',
      value: social?.whatsapp ? `+${String(social.whatsapp).replace(/[^\d]/g, '')}` : '',
      href: buildWhatsAppLinkAR(social?.whatsapp),
      icon: 'chat'
    },
    {
      title: 'Teléfono',
      value: contact?.phone || '',
      href: contact?.phone ? `tel:${contact.phone}` : null,
      icon: 'call'
    },
    {
      title: 'Email',
      value: contact?.email || '',
      href: contact?.email ? `mailto:${contact.email}` : null,
      icon: 'mail'
    },
    {
      title: 'Dirección',
      value: contact?.address || '',
      href: null,
      icon: 'location_on'
    },
    {
      title: 'Horario',
      value: contact?.schedule || '',
      href: null,
      icon: 'schedule'
    },
    {
      title: 'Instagram',
      value: social?.instagram || '',
      href: social?.instagram || null,
      icon: 'photo_camera'
    },
    {
      title: 'Facebook',
      value: social?.facebook || '',
      href: social?.facebook || null,
      icon: 'public'
    }
  ]).filter(i => i.value)
  }, [contact])

  return (
    <main className="w-full max-w-[1200px] mx-auto px-6 py-12">
      <div className="mb-10">
        <h1 className="text-4xl font-bold tracking-tight mb-2">Contacto</h1>
        <p className="text-gray-500">Escríbenos o visita nuestra tienda.</p>
      </div>

      {loading ? (
        <div className="text-sm text-gray-500">Cargando información de contacto...</div>
      ) : items.length === 0 ? (
        <div className="bg-white border border-[#eee] rounded-2xl p-8 text-sm text-gray-500">
          Aún no hay datos de contacto configurados en el sistema.
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {items.map((i) => (
            <div key={i.title} className="bg-white border border-[#eee] rounded-2xl p-6 flex gap-4 items-start">
              <div className="size-12 rounded-2xl bg-[#c27e70]/10 flex items-center justify-center text-[#c27e70] shrink-0">
                <span className="material-symbols-outlined">{i.icon}</span>
              </div>
              <div className="flex-1">
                <p className="text-xs font-bold uppercase tracking-widest text-gray-500">{i.title}</p>
                {i.href ? (
                  <a className="mt-2 block text-sm font-semibold text-[#181211] hover:text-[#c27e70] transition-colors break-words" href={i.href} target={i.href.startsWith('http') ? '_blank' : undefined} rel={i.href.startsWith('http') ? 'noreferrer' : undefined}>
                    {i.value}
                  </a>
                ) : (
                  <p className="mt-2 text-sm font-semibold text-[#181211] break-words">{i.value}</p>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </main>
  )
}

export default FashionContact
